import { defineStore } from 'pinia';
import { useRuntimeConfig } from '#app';
import type { LooseObject } from '~/types/generic';
import { param } from '~/utils/url';

interface Video extends LooseObject {
  id: string;
  title: string;
  url?: string;
  embed_url?: string;
  excerpt?: string;
  full_description?: Array<LooseObject> | string;
  blueprint: {
    handle: string;
  };
  seo?: Array<LooseObject>;
}

interface State {
  isLoading: boolean;
  currentVideo: Video | null;
}

interface VideoResponse extends LooseObject {
  data: Video[];
}

export const useVideosStore = defineStore('video', {
  state: (): State => ({
    isLoading: false,
    currentVideo: null,
  }),

  getters: {
    getCurrentVideo: (state: State) => state.currentVideo || {},
    hasCurrentVideo: (state: State) => !!(state.currentVideo && state.currentVideo.id),
  },

  actions: {
    setIsLoading(isLoading: boolean) {
      this.isLoading = isLoading;
    },

    setCurrentVideo(video = null) {
      this.currentVideo = video;
    },

    async loadSingle(slug: string) {
      if (this.currentVideo?.slug === slug) {
        return this.currentVideo;
      }

      this.isLoading = true;

      try {
        const runtime = useRuntimeConfig();
        const headerName = runtime.generateHeader;
        const headerValue = runtime.generateValue;
        const params = param({
          'filter[slug:equals]': slug,
        });
        const response: VideoResponse = await $fetch(`${useRuntimeConfig().public.apiUrl}/api/collections/videos/entries?${params}`, {
          headers: {
            [headerName]: headerValue,
          },
        });
        return response.data && response.data.length ? response.data[0] : null;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },

    setVideo(video: Video) {
      this.currentVideo = video;
    },
  },
});
